import { render, staticRenderFns } from "./ListFiles.vue?vue&type=template&id=24ce80b4&"
import script from "./ListFiles.vue?vue&type=script&lang=js&"
export * from "./ListFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports